import { render, staticRenderFns } from "./index.vue?vue&type=template&id=27f2cfdc&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=27f2cfdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f2cfdc",
  null
  
)

export default component.exports